<template>
    <form class="selector">
        <div class="form-group form-group-selectr">
            <label :for="parameter" v-html="parameters.title.value"></label>

            <select :id="parameter" class="form-control" :name="parameter" v-model="value" @change.stop="updateValue($event)">
                <option v-for="option in options" :value="option.id" v-html="option.value"></option>
            </select>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget.vue';

    export default {
        extends: VisibleSelectorWidget,
        props: {
            parameter: String,
        },

        created() {
            this.registerParameterListeners(this.parameters, [
                'title'
            ]);
        },

        methods: {
            broadcast(value) {
                const eventName = 'update' + this.parameter.replace(/^\w/, c => c.toUpperCase());
                window.events.emit(eventName, value);
            }
        }
    }
</script>
